import { inject, Injectable, signal } from '@angular/core';
import { LoggingService } from '../../../core/utils/logging.service';

export enum ELandingType {
  COMPANY = 'COMPANY',
  BUSINESS = 'BUSINESS',
}

export interface ILandingOrganizationInactive {
  type: ELandingType;
  title: string;
  subTitle?: string;
  image?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LandingOrganizationInactiveService {
  //inject
  private readonly loggingService = inject(LoggingService);

  landingOrganizationInactiveSignal = signal<ILandingOrganizationInactive | null>(null);

  setLandingOrganizationInactive(data: ILandingOrganizationInactive) {
    this.loggingService.log('Setting landing organization inactive data:', data);
    this.landingOrganizationInactiveSignal.set(data);
  }

  getLandingOrganizationInactive() {
    return this.landingOrganizationInactiveSignal;
  }
}
